import { BrandType } from 'src/constants/Brands';
import { Subvertical, Vertical } from '../constants/Verticals';
import { Flow } from 'src/hooks/Payment/types';
import { CountryCode } from 'src/constants/Countries';

export enum PageType {
    PERFORMANCE_PAGE = 'Performance page',
    CATEGORY_PAGE = 'Category page',
    PREQUIZ = 'Pre-quiz',
    QUIZ = 'Quiz',
    USER_PORTAL = 'User Portal',
    INBOX_ACTIVE = 'Inbox_Active',
    INBOX_CLOSED = 'Inbox_Closed',
    CHAT = 'Chat',
    LOGIN = 'Login',
    CREATE_ACCOUNT = 'Create Account',
    VERIFY_EMAIL = 'Verify Email',
    VERIFY_PHONE = 'Verify Phone',
    QUIZ_GATE = 'Quiz Gate',
    TREATMENT_ONBOARDING = 'Treatment Onboarding',
    TREATMENT_ONBOARDING__OVERVIEW = 'Treatment Onboarding - Overview',
    TREATMENT_ONBOARDING__STEP = 'Treatment Onboarding - Step',
    TREATMENT_ONBOARDING__ARTICLES = 'Treatment Onboarding - Articles',
    RESET_PASSWORD = 'Reset Password',
    RESET_PASSWORD_SUCCESS = 'Reset Password Success',
    RESET_PASSWORD_EXPIRED = 'Reset Password Expired',
    CREATE_PASSWORD = 'Create Password',
    CHECKOUT = 'Checkout',
    THANK_YOU = 'Thank You',
    PLAN_PAGE = 'Plan page',
    INITIAL = 'Initial',
    INITIAL__PLAN_CONSENT = 'Initial - Plan Consent',
    RENEWAL = 'Renewal',
    RENEWAL__CONFIRM_ADDRESS = 'Renewal - Confirm Address',
    RENEWAL__CONSENT = 'Renewal - Consent',
    RENEWAL__PLAN_CHANGE = 'Renewal - Plan Change',
    RENEWAL__PLAN_CONFIRM = 'Renewal - Plan Confirm',
    RENEWAL__THANK_YOU = 'Renewal - Thank you',
    INITIAL__DELIVERY_CONSENT = 'Initial - Delivery Consent',
    INITIAL__DOCTOR_INFO_CONSENT = 'Initial - Doctor Info Consent',
    INITIAL__PHOTO_WHY_CONSENT = 'Initial - Why We Need Your Photos',
    INITIAL__FRONT_PHOTO_CONSENT = 'Initial - Front Photo Verification',
    INITIAL__SIDE_PHOTO_CONSENT = 'Initial - Side Photo Verification',
    INITIAL__ID_VERIFICATION_CONSENT = 'Initial - ID Verification',
}

export enum DestinationCategory {
    QUIZ = 'Quiz',
    INBOX = 'Inbox',
    PRACTITIONER_CHAT = 'Practitioner Chat',
    USER_PORTAL = 'User portal',
}

export enum ButtonAction {
    DIRECT = 'Direct',
    SUBMIT = 'Submit',
    ACCORDION = 'Accordion',
    MODAL = 'Modal',
    SEND_MESSAGE = 'Send message',
}

type ErrorType = 'captcha_verification_failed';

export type EventProps = {
    brand?: BrandType;
    country_code?: CountryCode;
    button_action?: ButtonAction;
    vertical?: Vertical;
    subvertical?: Subvertical;
    quiz_name?: string;
    label?: string; // buttons / cards labels - CTAs
    question_name?: string;
    url?: string;
    quiz_type?: string;
    quiz_token?: string;
    version?: string;
    location?: string; // where it is located within a page
    destination_url?: string;
    destination_vertical?: Vertical;
    destination_category?: DestinationCategory;
    destination_brand?: BrandType;
    page_type?: PageType;
    medication?: string;
    referrer?: string;
    search?: string;
    experimentId?: string;
    variationId?: string;
    user_created_method?: string;
    user_created_source?: string;
    path?: string;
    title?: string;
    message_type?: string;
    chat_type?: string;
    gate_source?: string;
    gate_type?: string;
    // Plan
    plan?: string;
    planId?: string;
    plan_id?: string;
    // Checkout
    addon_ids?: Array<string>;
    value?: string;
    payment_method?: string;
    coupon_code?: string;
    discount_amount?: string;
    referral?: boolean;
    flow?: Flow;
    // Errors
    error_type?: ErrorType;
    error_message?: string;
};
